var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg00698IconServiceRemoteRendering(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd22e575-b917-4c6b-b5a7-5fd52e419078",
    x1: 9,
    y1: 15.379,
    x2: 9,
    y2: 2.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#1380da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#3c91e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#559cec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ea0ef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e88792aa-d42b-4571-a8a2-5af1dccbee2f",
    x1: -416.202,
    y1: -210.743,
    x2: -416.202,
    y2: -217.833,
    gradientTransform: "matrix(1, 0, 0, -1, 427.126, -205.758)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3f1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    stopColor: "#beeffe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#32bedd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a9f13b7f-95dc-4f59-87a4-8398fff3a7bb"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.875,11.439a3.989,3.989,0,0,0-3.461-3.834A5.026,5.026,0,0,0,9.237,2.8,5.156,5.156,0,0,0,4.309,6.159,4.759,4.759,0,0,0,.125,10.738a4.83,4.83,0,0,0,5,4.641c.148,0,.295-.007.44-.019h8.094a.789.789,0,0,0,.213-.032A4.036,4.036,0,0,0,17.875,11.439Z",
    fill: "url(#bd22e575-b917-4c6b-b5a7-5fd52e419078)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.371,9.669h0l2.3-4.522a.294.294,0,0,1,.522,0l2.29,4.32a1.571,1.571,0,0,1,.232.9c0,.948-1.248,1.716-2.788,1.716s-2.788-.768-2.788-1.716A1.179,1.179,0,0,1,8.371,9.669Z",
    fill: "url(#e88792aa-d42b-4571-a8a2-5af1dccbee2f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.371,9.707c-.189.381-.235.445-.235.691a1.181,1.181,0,0,0,.012.146c0,.019,0,.037,0,.056h.013c.14.733,1.032,1.325,2.189,1.475v-.148c-1.1-.147-1.945-.7-2.05-1.385.045-.687.879-1.426,2.05-1.591V8.864l-.023.013-.1-.056A2.933,2.933,0,0,0,8.541,9.7l.016-.031.712-1.4-.128-.074-.77,1.518Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "10.346 8.809 10.346 12.314 7.317 14.075 7.317 10.565 10.346 8.809",
    fill: "#9cebff"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "10.346 8.801 7.317 10.561 4.288 8.8 7.317 7.039 10.346 8.801",
    fill: "#9cebff",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "7.317 10.564 7.317 14.07 4.288 12.309 4.288 8.804 7.317 10.564",
    fill: "#9cebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.317,14.16l-3.1-1.8V8.767l3.1-1.8,3.1,1.8v3.589ZM4.361,12.272,7.317,13.99l2.955-1.718V8.852L7.317,7.133,4.361,8.851Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.712,10.359a1.571,1.571,0,0,0-.232-.9l-2.29-4.32a.294.294,0,0,0-.522,0L9.141,8.151l.128.074L10.8,5.213a.143.143,0,0,1,.131-.081.144.144,0,0,1,.13.078l2.29,4.32,0,.006,0,.006a1.214,1.214,0,0,1,.18.464,3.292,3.292,0,0,0-2.7-1.276,3.518,3.518,0,0,0-.608.053l.1.055.023-.013v.087a3.517,3.517,0,0,1,.489-.035c1.473,0,2.663.879,2.718,1.631-.127.8-1.257,1.42-2.629,1.42a4.335,4.335,0,0,1-.578-.04v.149a4.538,4.538,0,0,0,.578.038c1.429,0,2.605-.661,2.767-1.514h.014c0-.017,0-.034-.005-.051A1.085,1.085,0,0,0,13.712,10.359Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg00698IconServiceRemoteRendering);
export default __webpack_public_path__ + "static/media/00698-icon-service-Remote-Rendering.7c4f056282401996ac47e5bf6f40259a.svg";
export { ForwardRef as ReactComponent };